// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"14":"9a6ca7d3","188":"23580d5a","199":"7e43831d","294":"83311674","529":"a3817b0d","640":"405a2599","783":"30f47687","795":"f1e93c80","798":"a1005a7d","845":"61233620","914":"b0ce9aa6","954":"aee30b27"}[chunkId] + ".chunk.js";
};